import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";
import { HEADER_HEIGHT } from "../../components/templates/header/Header.style";

const style = () => {
  const { colorBgPrimaryLight, space12 } = theme();

  const style = StyleSheet.create({
    fiveItemsDiscountPadding: {
      paddingTop: space12,
    },
    headerWrapper: {
      display: "flex",
      flexDirection: "column",
    },
    safeAreaView: {
      backgroundColor: colorBgPrimaryLight,
    },
  });

  return {
    style,
    headerHeight: HEADER_HEIGHT,
    headerWithDoubleHeight: HEADER_HEIGHT * 2,
  };
};

export { style };
